import { useMemo } from "react";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { isOneTimePrice } from "@/react/helpers/paywallPriceHelpers";
import type { StripeElementsOptions } from "../../StripeElements/types";
import { stripeElementsModes } from "../../StripeElements/types";
import { getPaywallPrice } from "../helpers/paywallPrices";

export const useOptions = (): StripeElementsOptions => {
  const {
    currentCommunityProcessorPaymentMethodConfigurationId:
      paymentMethodConfiguration,
    currentCommunityMemberPaymentProcessorSessionClientSecret:
      customerSessionClientSecret,
    paywall,
    getSelectedPrice,
    previewMutation,
  } = usePaywallCheckoutContext();

  const selectedPrice = getSelectedPrice();
  const preview = previewMutation.data;

  const currency = paywall.currency_code;

  const price = getPaywallPrice(
    paywall,
    preview?.paywall_price_id ?? selectedPrice.id,
  );

  const mode = isOneTimePrice(price)
    ? stripeElementsModes.payment
    : stripeElementsModes.subscription;

  let amount = preview?.amount_due_now ?? 0;
  if (!amount) {
    if (isOneTimePrice(price)) {
      amount = price.amount;
    } else {
      amount = price.upfront_payment_amount || price.amount;
    }
  }

  return useMemo(
    () => ({
      paymentMethodConfiguration,
      customerSessionClientSecret,
      mode,
      currency,
      amount,
    }),
    [
      paymentMethodConfiguration,
      customerSessionClientSecret,
      mode,
      currency,
      amount,
    ],
  );
};
